import { render, staticRenderFns } from "./ViewBookingPositionJobandTalent.vue?vue&type=template&id=744bdba4&scoped=true&"
import script from "./ViewBookingPositionJobandTalent.vue?vue&type=script&lang=js&"
export * from "./ViewBookingPositionJobandTalent.vue?vue&type=script&lang=js&"
import style0 from "./ViewBookingPositionJobandTalent.vue?vue&type=style&index=0&id=744bdba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bdba4",
  null
  
)

export default component.exports